<div class="logo">
  <img src="assets/images/fleetoperate-logo.png" />
</div>

<div class="title">Unsubscription <span class="successful">Successful </span></div>

<p fxFlex>
  You have been unsubscribed from our email listing. <br> <br> If you change your mind, please contact us at <a href="mailto:{{contactEmail}}">{{contactEmail}}</a>
</p>

<div>
  Follow us<br><br>
  <a href="{{facebookURL}}"><img src="assets/images/facebook.png" class="social-media-imgs" /></a>
  <a href="{{twitterURL}}"><img src="assets/images/twitter.png" class="social-media-imgs" /></a>
  <a href="{{linkedInURL}}"><img src="assets/images/linkedin.png" class="social-media-imgs" /></a>
</div>

<div class="copyright">
  <hr> <br>
  <span>&copy; {{copyrightYear}} All Rights Reserved FleetOperate</span>
</div>
